export const TOUR_ACTIONS = {
  NAVIGATE: 'NAVIGATE',
  OPEN_TAB: 'OPEN_TAB',
};
